import { render, staticRenderFns } from "./resourcesRead.vue?vue&type=template&id=70b01330&scoped=true&"
import script from "./resourcesRead.vue?vue&type=script&lang=js&"
export * from "./resourcesRead.vue?vue&type=script&lang=js&"
import style0 from "./resourcesRead.vue?vue&type=style&index=0&id=70b01330&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b01330",
  null
  
)

export default component.exports